const v10 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        distributionProjectSummaryTable: {
          ...state.options.tableViews.distributionProjectSummaryTable,
          "Production Team": true,
        },
      },
    },
  };
};

export default v10;
